import { createStore } from "hooksy";

interface State {
  fetchList: boolean;
}

const defaultValue: State = { fetchList: false };

export const [useSystemAppNameStore] = createStore(defaultValue);
